// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-video-table .headRow .divCell:nth-child(1),
.manage-video-table .divRow .divCell:nth-child(1) {
    width: 80px !important;
}

.manage-video-table .divRow .divCell:nth-child(2),
.manage-video-table .divRow .divCell:nth-child(5),
.manage-video-table .headRow .divCell:nth-child(2),
.manage-video-table .headRow .divCell:nth-child(5) {
    width: 110px !important;
    word-break: break-word;
}
.manage-video-table .divRow .divCell:nth-child(3){
    width: 240px !important;
}
.manage-video-table .divRow .divCell:nth-child(4){
    width: 240px !important;
}
.manage-video-table .divRow .divCell:nth-child(6),
.manage-video-table .divRow .divCell:nth-child(7),
.manage-video-table .headRow .divCell:nth-child(6),
.manage-video-table .headRow .divCell:nth-child(7) {
    min-width: none;
    max-width: none;
    width: 300px !important;
    flex-grow: 1;
}

.manage-video-table .headRow .divCell:nth-child(8),
.manage-video-table .divRow .divCell:nth-child(8) {
    min-width: none;
    max-width: none;
    min-width: 50px !important;
}


/* head realated styles******************* */
.manage-video-table .headRow .divCell:nth-child(8) {
    text-align: center;
}


.manage-video-table .headRow .divCell:nth-child(2) {
    margin-right: 5px;
}


/* Row  releated styles******************** */
.manage-video-table .divRow .divCell:nth-child(8),
.manage-video-table .divRow .divCell:nth-child(9) {
    margin-right: 0px !important;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/screens/common/manageVideos/ManageVideos.css"],"names":[],"mappings":"AAAA;;IAEI,sBAAsB;AAC1B;;AAEA;;;;IAII,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;;;;IAII,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;;AAGA,4CAA4C;AAC5C;IACI,kBAAkB;AACtB;;;AAGA;IACI,iBAAiB;AACrB;;;AAGA,6CAA6C;AAC7C;;IAEI,4BAA4B;IAC5B,eAAe;AACnB","sourcesContent":[".manage-video-table .headRow .divCell:nth-child(1),\n.manage-video-table .divRow .divCell:nth-child(1) {\n    width: 80px !important;\n}\n\n.manage-video-table .divRow .divCell:nth-child(2),\n.manage-video-table .divRow .divCell:nth-child(5),\n.manage-video-table .headRow .divCell:nth-child(2),\n.manage-video-table .headRow .divCell:nth-child(5) {\n    width: 110px !important;\n    word-break: break-word;\n}\n.manage-video-table .divRow .divCell:nth-child(3){\n    width: 240px !important;\n}\n.manage-video-table .divRow .divCell:nth-child(4){\n    width: 240px !important;\n}\n.manage-video-table .divRow .divCell:nth-child(6),\n.manage-video-table .divRow .divCell:nth-child(7),\n.manage-video-table .headRow .divCell:nth-child(6),\n.manage-video-table .headRow .divCell:nth-child(7) {\n    min-width: none;\n    max-width: none;\n    width: 300px !important;\n    flex-grow: 1;\n}\n\n.manage-video-table .headRow .divCell:nth-child(8),\n.manage-video-table .divRow .divCell:nth-child(8) {\n    min-width: none;\n    max-width: none;\n    min-width: 50px !important;\n}\n\n\n/* head realated styles******************* */\n.manage-video-table .headRow .divCell:nth-child(8) {\n    text-align: center;\n}\n\n\n.manage-video-table .headRow .divCell:nth-child(2) {\n    margin-right: 5px;\n}\n\n\n/* Row  releated styles******************** */\n.manage-video-table .divRow .divCell:nth-child(8),\n.manage-video-table .divRow .divCell:nth-child(9) {\n    margin-right: 0px !important;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
